/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { InvitedUserFields, InvitedUser } from 'src/app/app-data/models/InvitedUser';
import { tap } from 'rxjs/operators';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FancyAction } from '../base/FancyAction';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { DefaultSplitDataRenderType, escapeEmail } from '@touchplan/common';
import { DefaultActionTypes } from '../generics/DefaultActionTypes';

export class InvitedUserList
	extends FancyFirebaseSplitDataList<InvitedUserFields, DefaultSplitDataRenderType, InvitedUser>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const user = new InvitedUser(action.payload.key);
		user.databaseUpdate(action.payload.val());
		return user;
	}
	public $$updated(child: InvitedUser, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public handleCustomEvents(baseObservable) {
		return super.handleCustomEvents(baseObservable).pipe(
			tap((action: FancyAction<InvitedUser>) => {
				if (action.type === DefaultActionTypes.addItem) {
					const projectId = this.listRef.query.ref.key;
					this.writeEmailIndex(action.payload.view.email, projectId, true);
				}
			})
		);
	}

	private writeEmailIndex(email: string, projectId: string, writeOrRemove: boolean) {
		const valueToWrite = writeOrRemove ? projectId : null;
		const encodedEmail = escapeEmail(email);
		//relatively navigate to the from the project entry to the email entry
		this.listRef.query.ref.parent.parent
			.child('emails')
			.child(encodedEmail)
			.child('projects')
			.child(projectId)
			.set(valueToWrite);
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child: InvitedUser, otherChild: any) {
		switch (baseKey) {
			case 'roleId':
				child.view.color = otherChild ? otherChild?.view.color : null;
				break;
			default:
				break;
		}
	}
	public getDataForKey(baseKey: string, child: InvitedUser) {
		return child.view[baseKey];
	}
}
